import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';

@Component({
	selector: 'app-dropdown-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzSelectModule],
	templateUrl: './dropdown-control.html',
})
export class DropdownControl {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	options = input.required<{ value: string | number; label: string }[]>();
	formGroup = input.required<FormGroup>();
}
